var _a;
var POSTS_TABS_KEYS = {
    FEED: 1,
    PINNED_POSTS: 2,
};
var POSTS_TABS = (_a = {},
    _a[POSTS_TABS_KEYS.FEED] = { label: "Feed", value: POSTS_TABS_KEYS.FEED },
    _a[POSTS_TABS_KEYS.PINNED_POSTS] = {
        label: "Pinned posts",
        value: POSTS_TABS_KEYS.PINNED_POSTS,
    },
    _a);
var POSTS_TABS_LIST = [
    POSTS_TABS[POSTS_TABS_KEYS.FEED],
    POSTS_TABS[POSTS_TABS_KEYS.PINNED_POSTS],
];
var POSTS_LIST_PAGE_DEFAULT_DATA = {
    total_pages: 0,
    posts: [],
    total: 0,
};

export { POSTS_LIST_PAGE_DEFAULT_DATA, POSTS_TABS, POSTS_TABS_KEYS, POSTS_TABS_LIST };
//# sourceMappingURL=PostsListContainer.js.map
